import logoUrl from '../../assets/fruuit-logo-480.png'
import markUrl from '../../assets/fruuit-mark.png'
import { cn } from '../cn'

export const PRODUCT_NAME = 'Fruuit Engage'

/** The full Fruuit Consulting logo (tree + wordmark), trimmed. 480×288 source. */
export function BrandLogo({ className }: { className?: string }) {
  return (
    <img
      src={logoUrl}
      alt="Fruuit Consulting"
      width={480}
      height={288}
      className={cn('h-auto w-40', className)}
    />
  )
}

/** The tree mark on its own. Decorative unless given a label. */
export function BrandMark({ className, label }: { className?: string; label?: string }) {
  return (
    <img
      src={markUrl}
      alt={label ?? ''}
      aria-hidden={label ? undefined : true}
      width={139}
      height={96}
      className={cn('h-8 w-auto', className)}
    />
  )
}

/** Tree mark + "Fruuit Engage" wordmark, as used in the top bar. */
export function ProductLockup({ className, compact }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <BrandMark className={compact ? 'h-7' : 'h-8'} />
      <span className="flex flex-col leading-none">
        <span className="font-display text-[17px] font-semibold tracking-[-0.01em] text-teal">
          {PRODUCT_NAME}
        </span>
        {compact ? null : (
          <span className="mt-1 text-xs font-medium text-sage">by Fruuit Consulting</span>
        )}
      </span>
    </span>
  )
}
